<template>
  <section class="pdp-gallery" :class="{'pdp-gallery--zooming': zoomState}">
    <div class="pdp-gallery__main-container">
      <div class="pdp-gallery__main--mobile u-hidden-tablet-up">
        <span class="pdp-gallery__zoom-icon" @click="() => zoomState = false" v-if="zoomState">
          <icon name="zoom_out"></icon>
        </span>
        <span class="pdp-gallery__zoom-icon" v-else @click="zoomCenter">
          <icon name="zoom_in"></icon>
        </span>
        <swiper :options="swiperOptionsMain" ref="swiperMain" :key="mainSwiperKey">
          <swiper-slide v-for="(media) in productMedia" :key="media.id">
            <div @click="setZoom($event, !zoomState)" @mouseleave="() => zoomState = false">
              <media :media="media">
                <zoom ref="zoom" slot="image" :img-normal-attrs="{ src: media.src, alt: getProductImageAlt(media) }" :img-zoom-attrs="{ src: media.src, alt: getProductImageAlt(media) }" :zooming="zoomState" :disabled="!zoomState"></zoom>
              </media>
            </div>
          </swiper-slide>
        </swiper>
        <div class="pdp-gallery__pagination" slot="pagination" v-if="productMedia.length > 1"></div>
      </div>
      <div class="pdp-gallery__main">
        <div v-for="(media, idx) in productMedia" :key="media.id" ref="mainImages" class="pdp-gallery__main-image" :data-img="idx">
          <zoom ref="zoom" slot="image" :img-normal-attrs="{ src: media.src, alt: getProductImageAlt(media) }" :img-zoom-attrs="{ src: media.src, alt: getProductImageAlt(media) }" :zooming="slideIndexMain === idx && zoomState" :disabled="!zoomState"></zoom>
        
          <span class="pdp-gallery__zoom-icon" @click="() => zoomState = false" v-if="zoomState">
            <icon name="zoom_out"></icon>
          </span>
          <span class="pdp-gallery__zoom-icon" v-else @click="zoomCenter">
            <icon name="zoom_in"></icon>
          </span>
        </div>
      </div>
      <div class="pdp-gallery__thumbs">
        <div class="pdp-gallery__thumbs-slider" ref="thumbSwiper">
          <div v-for="(media, index) in productMedia" :key="media.src" class="pdp-gallery__thumbs-slide" :class="{'pdp-gallery__thumbs-slide--active': slideIndexMain === index, [settings.thumbnailColor]: slideIndexMain === index}" ref="thumbImages">
            <button @click="thumbSlideTo(index)" :aria-label="`Go to Thumbnail ${index}`">
              <media-preview :media="media" size="160x"></media-preview>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@/scripts/typedefs'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { imageSize, fileUrl, noImageMedia, swiperLoopInit, swiperLoopSlideChange, is3rdPartyProduct, badgeList, getProductImageAlt, badge, getVariantImages } from '@/scripts/helpers/util'
import Icon from '@/scripts/components/basic/Icon.vue'
import Zoom from '@/scripts/components/basic/Zoom.vue'
import Media from '@/scripts/components/basic/Media.vue'
import MediaPreview from '@/scripts/components/basic/MediaPreview.vue'
import inView from 'in-view'
import scrollIntoView from 'scroll-into-view-if-needed'

export default {
  components: {
    swiper,
    swiperSlide,
    Zoom,
    Icon,
    Media,
    MediaPreview
  },
  model: {
    prop: 'variant'
  },
  props: {
    collection: Object,
    product: Object,
    customFields: Object,
    settings: Object,
    variant: Object
  },
  data () {
    return {
      zoomState: false,
      initialSlide: 0,
      mainSwiperKey: 0,
      thumbSwiperKey: 0,
      thumbsShouldSlide: false,
      scrolling: false,
      slideIndexMain: 0
    }
  },
  computed: {
    /**
     * @desc
     *  - look for images with alt tags that are either women or men and display the appropriate images, or show all images if not unisex
     */
    productMedia () {
      const images = this.product.media;
      const query = window.location.search;
      const params = new URLSearchParams(query);
      const womens = params.get('womens');
      const mens = params.get('mens');

      if (womens)
        return images.filter(image => !image.alt || !image.alt.split(' ').includes('mens'));
      else if (mens)
        return images.filter(image => !image.alt || !image.alt.split(' ').includes('womens'));
      else
        return images;
    },
    onSale () {
      return this.variant && this.variant.price < this.variant.compare_at_price
    },
    badges () {
      return badgeList(this.product, this.onSale)
    },
    swiperOptionsMain () {
      const vue = this;
      return {
        initialSlide: 0,
        pagination: {
          el: '.pdp-gallery__pagination',
          clickable: true
        },
        threshold: 50,
        iOSEdgeSwipeDetection: true,
        iOSEdgeSwipeThreshold: 100,
        slidesPerView: 1.2,
        spaceBetween: 4,
        loop: true
      }
    }
  },
  methods: {
    scrollIntoView(...params) {
      this.scrolling = true;
      scrollIntoView(...params);

      // allow 2 seconds for scrolling.
      setTimeout(() => {
        this.scrolling = false;
      }, 2000)
    },
    zoomCenter (event) {
      this.zoomState = true
      this.$nextTick(() => {
        const zoomContainer = this.$refs.zoom[this.slideMobileIndexMain()]
        if (zoomContainer) { zoomContainer.zoomCenter() }
      })
    },
    setZoom (event, state) {
      this.zoomState = state
      this.$nextTick(() => {
        const zoomContainer = this.$refs.zoom[this.slideMobileIndexMain()]
        if (zoomContainer) { zoomContainer.move(event) }
      })
    },
    slideMobileIndexMain () {
      if (!this.$refs.swiperMain) return 0
      return this.$refs.swiperMain.swiper.activeIndex - 1
    },
    slideMobileRealIndexMain () {
      if (!this.$refs.swiperMain) return 0
      return this.$refs.swiperMain.swiper.realIndex
    },
    getProductImageAlt,
    thumbSlideTo (index) {
      this.scrollIntoView(this.$refs.mainImages[index])
    }
  },
  mounted () {
    inView.threshold(0.51);
    inView('.pdp-gallery__main-image').on('enter', (el) => {
      this.slideIndexMain = Number(el.dataset.img)

      if (!this.scrolling) {
        this.scrollIntoView(this.$refs.thumbImages[Number(el.dataset.img)], { behavior: "smooth", block: "nearest" })
      }
    });
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .swiper-wrapper {
    display: flex;
    align-items: center;
  }

  /deep/ .swiper-pagination-bullet {
    width: 5px;
    height: 5px;
    border: 1px solid $color-off-black;
    opacity: 1;
    background: transparent;
    margin: 0 1px;
  }

  /deep/ .swiper-pagination-bullet-active {
    background: $color-off-black;
  }

  /deep/ .swiper-slide {
    height: auto !important;
    img {
      display: block;
    }
  }

  .pdp-gallery {
    margin: 0;
    width: 100%;

    &__main-image {
      width: 100%;
    }

    &__main--mobile {
      position: relative;
      padding-left: 15px;
    }

    .zoom-on-hover {
      text-align: center;
    }

    &__badge-container {
      position: absolute;
      top: 0;
      left: 0;
      min-height: 25px;
    }

    &__logo-badge {
      z-index: 4;
      height: 40px;
      margin-right: 16px;
      margin-left: 5%;
      img {
        height: 40px;
        width: auto;
      }
      @include mobile-only {
        height: 35px;
        img {
          height: 35px;
        }
      }
    }

    .badge {
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none;
      padding: 0 32px;
      line-height: 26px;
      height: 25px;
      font-size: rem(12);

      &.has-logo-badge {
        @include mobile-only {
          margin-left: auto;
          margin-right: 5%;
        }
      }
    }

    &__button {
      display: none;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 5;
      font-size: 0;
      cursor: pointer;
    }

    &__pagination {
      margin-top: 10px;
      position: relative;
      font-size: 0;
      z-index: 11;
    }

    &__button--next {
      right: 8px;
    }

    &__button--prev {
      left: 8px;
    }

    &__button--next svg {
      margin-right: -2px;
    }

    &__button--prev svg {
      margin-left: -2px;
      transform: rotate(180deg);
    }

    &__zoom-icon {
      position: absolute;
      top: 15px;
      right: 15px;
      display: inline-block;
      width: 30px;
      height: 30px;
      background: $color-zoom-background;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 31;
      cursor: pointer;
      box-shadow: 0 0 8px 0 rgba(0,0,0,0.1);

      @include mobile-only {
        top: auto;
        bottom: 28px;
        pointer-events: none;
      }
    }

    &__zoom-icon * {
      pointer-events: none;
    }

    &__thumbs {
      display: none;

      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &__main {
      position: relative;
      display: none;
    }

    @include tablet-up {
      display: inline-block;
      min-width: 50%;
      flex-basis: 50%;
      width: 50%;

      &__badge-container {
        display: flex;
      }

      &__main-container {
        display: inline-flex;
        justify-content: flex-end;
        max-width: 100%;
        width: 100%;
        position: relative;
      }

      &__main {
        display: block;
        width: calc(100% - 119px);
        order: 1;
        position: relative;
        padding-left: 4px;
      }

      &__main-image {
        position: relative;
        margin-bottom: 4px;
      }

      &__badge-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      &__main &__button {
        opacity: 0;
        transition: opacity .2s linear;
      }

      &:hover &__main &__button {
        opacity: 1;
      }

      &__pagination {
        display: none;
      }

      &__thumbs {
        display: block;
      }

      &__thumbs-slider {
        max-height: 100%;
      }

      &__thumbs-slider .swiper-slide {
        border: 0;
        display: flex;
      }

      &__thumbs-slide {
        margin-bottom: 4px;
      }

      &__thumbs-slide--active {
        position: relative;
        &:after {
          content: '';
          height: 6px;
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          background: $color-black;
        }
      }

      &__thumbs-slider .swiper-slide-duplicate {
        opacity: 0;
        visibility: hidden;
      }

      &__thumbs-slider button {
        height: 100%;
        width: 100%;
        overflow: hidden;
      }

      &__thumbs-slider img {
        // width: 153px;
        max-width: 100%;
      }

      .zoom-on-hover {
        cursor: zoom-in;
      }

      .zoom-on-hover .zoom {
        cursor: zoom-out;
      }
      &__zoom-icon svg {
        width: 28px !important;
        height: 28px !important;
      }

      &__button {
        width: 40px;
        height: 40px;
      }

      &__thumbs {
        position: sticky;
        display: flex;
        align-items: center;
        display: inline-block;
        max-width: 116px;
        top: 80px;
        height: calc(100vh - 80px);
        overflow-y: scroll;
      }

      &__button-thumb {
        display: none;
        position: absolute;
        left: 0;
        width: 80px;
        height: 32px;
        background: $color-black;
        opacity: .3;
        align-items: center;
        justify-content: center;
        z-index: 5;
        transition: right .2s .2s ease, left .2s .2s ease;
      }

      &__button-thumb svg {
        fill: $color-white;
      }

      &__button-thumb--next {
        bottom: 0;
      }

      &__button-thumb--prev {
        top: 0;
      }

      &__button-thumb--next:disabled {
        bottom: -33px;
      }

      &__button-thumb--prev:disabled {
        top: -33px;
      }
    }

    @include desktop-up {
      width: 58%;
    }
  }

  .pdp-gallery.pdp-gallery--zooming {
    .pdp-gallery__main .pdp-gallery__button {
      pointer-events: none;
      opacity: 0;
    }
  }
</style>
